module.exports = __webpack_public_path__ + "img/shipinjiankong.fde20d3e.png";